import { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";

const KEY = "ra_consent";

export default function ConsentBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => { try { if (!localStorage.getItem(KEY)) setShow(true); } catch { /* ignore */ } }, []);
  const decide = (v) => { try { localStorage.setItem(KEY, v); } catch { /* ignore */ } setShow(false); };
  if (!show || window.location.pathname.startsWith("/video-review/")) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-[1500] p-3 sm:p-4 pointer-events-none" data-testid="consent-banner">
      <div className="max-w-4xl mx-auto rounded-xl bg-ink text-white shadow-2xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4 pointer-events-auto">
        <Cookie className="w-6 h-6 text-terracotta shrink-0" />
        <p className="text-sm text-white/85 flex-1">
          We use cookies and links to understand where our travellers come from and to improve your experience.
          Some campaigns are run with marketing partners; this helps us credit them fairly. See our privacy policy for details.
        </p>
        <div className="flex gap-2 shrink-0">
          <button onClick={() => decide("declined")} data-testid="consent-decline" className="h-9 px-4 rounded-sm border border-white/30 text-white text-sm font-semibold hover:bg-white/10 transition-colors">Decline</button>
          <button onClick={() => decide("accepted")} data-testid="consent-accept" className="h-9 px-4 rounded-sm bg-terracotta hover:bg-terracotta-hover text-white text-sm font-semibold transition-colors">Accept</button>
        </div>
      </div>
    </div>
  );
}
